import { BrandMediaEditor, useBrandMedia } from "~/common/media/brand-media";

type Asset = { file_id: string; url: string; type: string; mime: string };
type Media = { url: string; type?: string; mime?: string };
/** Shared Files picker, with private references until the server saves this plan. */
export function ChannelMediaEditor({
	brandId,
	assets,
	value,
	onChange,
	disabled,
	accept,
	maxCount,
	onBusyChange,
}: {
	brandId: string;
	assets: Asset[];
	value: Media[];
	onChange: (value: Media[]) => void;
	disabled: boolean;
	accept: string;
	maxCount: number;
	onBusyChange?: (busy: boolean) => void;
}) {
	const media = useBrandMedia(brandId);
	return (
		<BrandMediaEditor
			media={media}
			value={value.map((item) => ({
				url: assets.find((a) => a.url === item.url)
					? `ondit-file:${assets.find((a) => a.url === item.url)!.file_id}`
					: item.url,
				alt: "",
			}))}
			allowUrl={false}
			disabled={disabled}
			accept={accept}
			maxCount={maxCount}
			onBusyChange={onBusyChange}
			onChange={(items) =>
				onChange(
					items.map((item) => {
						const file = media.files.find((f) => f.id === item.url);
						const asset = assets.find((a) => `ondit-file:${a.file_id}` === item.url);
						const mime = file?.type ?? asset?.mime;
						return { url: item.url, ...(mime ? { mime, type: mime.split("/")[0] } : {}) };
					}),
				)
			}
		/>
	);
}
